/*
 * If you change the following items in the config object, you will not see any effect in the local development server
 * as these are stored in the cookie (cookie has the highest priority over the themeConfig):
 * 1. mode
 * 4. layout
 *
 * To see the effect of the above items, you can click on the reset button from the Customizer
 * which is on the top-right corner of the customizer besides the close button.
 * This will reset the cookie to the values provided in the config object below.
 *
 * Another way is to clear the cookie from the browser's Application/Storage tab and then reload the page.
 */

import type { PaletteMode } from '@mui/material';

interface Config {
  templateName: string;
  settingsCookieName: string;
  mode: PaletteMode;
  layoutPadding: number;
  compactContentWidth: number;
}

const themeConfig: Config = {
  templateName: 'Eon',
  settingsCookieName: 'eon-settings',
  mode: 'light', // 'system', 'light', 'dark'
  layoutPadding: 24, // Common padding for header, content, footer layout components (in px)
  compactContentWidth: 1440, // in px
};

export { themeConfig };
